import {MapController} from "./map"
import MODAL from './modal'
import '../../components/offcanvas/offcanvas_menu'
import _offcanvas from "./_offcanvas";
import("../../../styles/pages/raining_now/base.css"); //Importando o css do Javascript
import '../../components/map/smoth_zoom/smoth_zoom'

import Offcanvas from "../../components/new_offcanvas/offcanvas_menu";
import _http_v1 from '../../http_requests/_http_v1'
import filter_form from "./filter_form";
import Legend from "./components/legend/legend";
import toast from '../../components/toast/toast'
import EventAlert from "./components/event_alert";
import EventsHandler from "./_events_handler";
import Supporters from "../../components/map/supporters/supporters";
import("./components/event_alert.css")

import Title from "./components/title";
import('./components/title.css')

import LoadingBar from "./components/loading_bar";
import('./components/loading_bar.css')
import('./components/popup/popup.scss')

import product_title from "./components/product_title/product_title";
import store from "./store/store";
import stationHelper from "./helpers/station_helper";
import MarkersComponent from "./components/markers/markers";
import ChartModal from "@components/modal/chart_modal/chart_modal";
import TypeSelector from "./components/type_selector/type_selector";
import MapOverlay from "./components/map_overlay/map_overlay";

import colors from "./helpers/colors";
import locale from "@packs/locale/locale";
import OffcanvasController from "./components/offcanvas/offcanvas_controller";

import EdgeProgressBar from "@components/progress/edge_progress_bar/edge_progress_bar";
import geoJSONHelper from "./helpers/geoJSON";

import PopUpComponent from "./components/popup/popup";
import LandSlide from "./components/landslide/landSlide";
import MouseTooltip from "./components/mouse_tooltip/MouseTooltip";
import MapNavbarController from './map_navbar_controller'
import TimelineController from './components/timeline/TimelineController'
import Lightning from "./components/lightnings/Lightning";

global.RBush = require('@packs/leaflet/RBush') //dependência camada de markers com canvas
require('@packs/leaflet/leaflet_canvas_markers') ////camada de markers com canvas


const LOAD_MEASUREMENTS_TIMER = 1000 * 60 * 1
let offcanvasFilter = new Offcanvas({id: "offcanvas_filter", title: 'Filtrar Postos'})
let loading_bar = new LoadingBar({timer: LOAD_MEASUREMENTS_TIMER})
let chartModal
let markersComponent
let mapOverlay
let offcanvasController

let filter_options = {
  ugrhi_ids: [],
  legends: [0,1,2,3],
  city_ids: []
}
let user_options = {
  new_events: true,
  critical_events:true
}
let events_handler = new EventsHandler()
let main_title = new Title({hours:72})


let INTERVAL

let FEATURE_GROUPS = {}

global.CAN_SEE_RADAR_DAEE = false
if(Array.isArray(cookies.roles)){
  if(cookies.roles.includes('dev') || cookies.roles.includes('admin')){
      global.CAN_SEE_RADAR_DAEE = true
  }
} else if(cookies.roles && ['dev','admin'].includes(cookies.roles)) {
  global.CAN_SEE_RADAR_DAEE = true
}


$(function(){
  moment.locale("pt-br")
  geoJSONHelper.loadUgrhisFeatures() //carregando camadas JSON simplificadas de ugrhis

  $("section").removeClass("pb-2");
  var returnedFunction = debounce(function() {
    
    const element = document.documentElement;
    const scrollbarWidth = window.innerWidth - element.clientWidth;

    const HEADER_SIZE = $("#main_header").outerHeight();
    const FOOTER_SIZE = $("#main_footer").outerHeight();
    const NAVIGATION_SIZE = 0;

    if(mobileCheck()){
      $('.legend-container').css({
        "display": "flex",
        'bottom': 0
      })
      var legend_mobile_space = $(".legend-container").outerHeight();
      $("section").css({
        "height": (window.innerHeight - HEADER_SIZE - legend_mobile_space ),
        "min-height": (window.innerHeight - HEADER_SIZE - legend_mobile_space)
      })
      
    } else{
      $("section").css({
        "height": (window.innerHeight - HEADER_SIZE - FOOTER_SIZE ),
        "min-height": (window.innerHeight - HEADER_SIZE - FOOTER_SIZE )
      })
      $('.legend-container').css({
        "bottom": FOOTER_SIZE - scrollbarWidth + 5,
        // "display": "flex"
      })
    }
    map.invalidateSize();
  }, 250);

  window.addEventListener('resize', returnedFunction);  
  
  offcanvasFilter.generate()
  buildFilter()

  loading_bar.generate()
  
  initialMapLoad();
  setHighchartsConfig()
  
  let _legend = new Legend()
  _legend.generate()

  let mouseTooltip = new MouseTooltip()

  offcanvasController = new OffcanvasController()

  offcanvasController.on('EVENT_TABLE_ROW_MOUSEOVER', (data)=>{
    if(!FEATURE_GROUPS['EVENT_TABLE_HOVER']){
      FEATURE_GROUPS['EVENT_TABLE_HOVER'] = new L.featureGroup()
      map.addLayer(FEATURE_GROUPS['EVENT_TABLE_HOVER'])
    } 
    
    if(data.type==='ugrhi'){
      //esperando o cod da ugrhi no 'obj'
      geoJSONHelper.ugrhiFeatures.forEach(feature=>{
        if(feature.cod === parseInt(data.obj)){
          FEATURE_GROUPS['EVENT_TABLE_HOVER'].addLayer(feature)
        }
      })
    }
  })

  offcanvasController.on('EVENT_TABLE_ROW_MOUSEOUT', (data)=>{
    if(FEATURE_GROUPS['EVENT_TABLE_HOVER']){
      FEATURE_GROUPS['EVENT_TABLE_HOVER'].clearLayers()
    }
  })

  offcanvasController.on('EVENT_TABLE_ROW_CLICK', data=>{
    if(data.type === 'station'){
      markersComponent.zoomToStation(data.obj)  
    } else {
      map.fitBounds(FEATURE_GROUPS['EVENT_TABLE_HOVER'].getBounds())
    }
  })

  returnedFunction()
  
  // loadMeasurements(hours)
  
  let event_alert = new EventAlert()
  mapOverlay = new MapOverlay()
  
  //gerando titulo que aparece ao esconder elementos informativos
  main_title.generate()

  //gerando menus de controle do modal de opções gerais
  setUserOptions()

  //adicionando logos de apoio na tela
  addSupporters()

  //adicionando titulo do chuva agora
  // generateProductTitle()

  store.mainConfigStore.setType('plu')
  
})


// ######################### ALL DELEGATES ############################
$(document).on(".legend-stations .legend, #legend_mobile .legend",'click', function(e,x){
  var data_id = parseInt(e.target.dataset.id)
  if(filterOptions.hasOwnProperty("legend")){
    if(filterOptions.legend.includes(data_id)){
      filterOptions.legend.splice(filterOptions.legend.indexOf(data_id), 1)
    } else {
      filterOptions.legend.push(data_id)
    }
    MapController.filterMeasurementsByLegends(filterOptions.legend);
    MapController.filterMeasurements();
    MapController.showMarkersOnMap();
    $(this).toggleClass("active")
  } else {
    console.log('object filter corrupted')
  }
})

$(document).on('open_config', ()=>{
  $('#modal_config').modal('show')
})

$(document).on('click', '.config-option-container', function(){
  let key = this.dataset.id
  $(this).toggleClass('active')
  user_options[key] = !user_options[key]
  localStorage.setItem('raining_now_user_options', JSON.stringify(user_options))
})


$(document).on('filter_markers:legend', (e, data)=>{
  let data_id = data.data_id
  let index = filter_options.legends.indexOf(data_id)
  if(index >= 0){
    filter_options.legends.splice(index, 1)
  } else {
    filter_options.legends.push(data_id)
  }
  if(filterOptions.hasOwnProperty("legend")){
    if(filterOptions.legend.includes(data_id)){
      filterOptions.legend.splice(filterOptions.legend.indexOf(data_id), 1)
    } else {
      filterOptions.legend.push(data_id)
    }
    filterStations()
    
  } else {
    console.log('object filter corrupted')
  }
  // console.log(data);
})

$(document).on('click', '#checkbox_ugrhi_limit', function(){
	if(this.checked){
		MapController.loadUgrhisLayer(ugrhis.map(x=>x.cod.toString()));
	} else {
		featureGroupUgrhiLimit.clearLayers();
	}
})
$(document).on('click', '#checkbox_city_limit', function(){
	if(this.checked){
		MapController.loadCitiesLayer([], true);
	} else {
		featureGroupCityLimit.clearLayers();
	}
})

$(document).on('map:open_filter', ()=>{
  offcanvasFilter.show()
})

$(document).on('map:filter', (e, data)=>{
  filter_options.ugrhi_ids = data.ugrhi_ids
  filter_options.city_ids = data.city_ids
  filterStations();
})


$(document).on('click', '#checkbox_monitored_spots', function(){
	if(this.checked){
    MapController.loadMonitoredSpotsMarkers();
	} else {
		markers_monitored_spots.clearLayers();
	}
})

store.mainConfigStore.subscribe('HOURS_UPDATE', data =>{
  localStorage.setItem('sibh_raining_now_hours', store.mainConfigStore.getHours())
  if(store.mainConfigStore.getType() === 'plu'){
    pluLoad()
  } else {

  }
})

store.mainConfigStore.subscribe('DATE_UPDATE', data =>{
  if(store.mainConfigStore.getType() === 'plu'){
    pluLoad()
  } else {
    fluLoad()
  }
})

store.mainConfigStore.subscribe('TYPE_UPDATE', data =>{
  if(data === 'plu'){
    pluLoad()
  } else {
    fluLoad()    
  }
  
})

store.modalConfigStore.subscribe('SET_STATION_IDS', data=>{
  let stations = store.fluConfig.getStations()
  // console.log(stations, data);
  
  let station = stations.filter(s=>s.station_prefix_id === data[0])[0]
  let TYPE = store.mainConfigStore.getType()
  let yaxis_options = [
    {
      station_type:'level', 
      name: 'Nível', 
      label_format: '{value} m', 
      value_type: 'm', 
      reference_values: store.mainConfigStore.getType() === 'flu' ? [station.parameter] : []
    }]
  
  chartModal.updateStations(data)

  chartModal.updateModalTitle(station.station_name || station.station.name, station.prefix)

  chartModal.updateReferenceValues(store.mainConfigStore.getType() === 'flu' ? station.parameter : [])

  if(TYPE === 'plu'){
    yaxis_options = [{station_type:'plu', name: 'Chuva', label_format: '{value} mm', value_type: 'mm'}]
  }

  chartModal.updateYaxisOptions(yaxis_options)

  chartModal.show()
})

store.landslideConfigStore.subscribe('SET_OPTION', data=>{
  if(data.option === 'active'){
    if(data.value === true){
      store.mainConfigStore.setOption('hide_all_markers', true)
    }
  }
})


$(".container_partners .close").on('click',function(){
  $(".container_partners.partners").removeClass("show")
})
$("#filter_box .close").on('click',function(){
  $("#filter_box").removeClass("show")
})

$(document).on('click', ".btn-hide-boxes", function(){
  
	var attr = $(this).attr("data-value");
	if(attr == "hide"){
    main_title.setHours(hours)
    main_title.show(0)
		$(".dom-element-default").css("opacity", 0);
		$(".dom-element-default").css("visibility", 'hidden');
		$(".titulo-produto").css("display", "block");
		$(this).attr("data-value","show");
    $(this).html('<i class="fas fa-eye"></i>');
    $(this).attr("title", "Exibir elementos informativos");
	}else{
    main_title.hide(0)
		$(this).attr("data-value","hide");
		$(".dom-element-default").css("opacity", 0.8);
		$(".dom-element-default").css("visibility", 'visible');
		$(".titulo-produto").css("display", "none");
    $(this).html('<i class="fas fa-eye-slash"></i>');
    $(this).attr("title", "Esconder elementos informativos");
	}
})

$(document).on('click', '.container_partners.initial', function(){
	$(".container_partners.partners").toggleClass("show");
  $(this).find(".footer .fa-caret-down, .footer .fa-caret-up").toggleClass("invisible");
})

$(document).on('show.bs.modal', "#modal_chart", function(e){
  let station_prefix_id = e.relatedTarget.dataset.id
  MODAL.generateChart(station_prefix_id)
})

$(document).on('click', '.btn-report-station', function(e){
  let id = e.target.dataset.id
  OffcanvasMenu.show()
  _offcanvas.buildContent(id, '#card_offcanvas .content')
})

$(document).on('report_created', '#card_offcanvas .content', function(e, report){
  OffcanvasMenu.hide()
})

$(document).on('EventAlert::more-button-click', (e, prefix)=>{
  MapController.showMakerOnMap(prefix)
})

// ######################### ALL DELEGATES ############################

const configInterval = _ =>{
  if(INTERVAL){
    clearInterval(INTERVAL)
  }
  
  let DATE = store.mainConfigStore.getDate()
  
  if(!DATE){
    INTERVAL = setInterval(_=>{
      store.mainConfigStore.setType(store.mainConfigStore.getType())
    }, LOAD_MEASUREMENTS_TIMER)  
  }  
}


const progressBarHandler = _ =>{
  let DATE = store.mainConfigStore.getDate()
  loading_bar.reset()
  
  if(DATE){
    loading_bar.stop()
    loading_bar.updateText(new Date(DATE).toLocaleString().slice(0, -3))
  } else {
    loading_bar.move()
    loading_bar.updateText(new Date().toLocaleString().slice(0, -3))
  }
}


const pluLoad = () =>{
  configInterval()
  progressBarHandler()
  mapOverlay.show()
  stationHelper.getMeasurements('plu').then(data=>{
    data.measurements.map(x=>x.id = x.station_prefix_id) //
    store.fluConfig.setStations(data.measurements)

    data.measurements.forEach(measurement=>{
      store.fluConfig.setStationProp(measurement.station_prefix_id, 'value', measurement.value)
    })
    
    markersComponent.filterMarkers() //filtrando markers de acordo com o filtro atual

    offcanvasController.update() //recarregando dados do offcanvas

    mapOverlay.hide() //removendo overlay do mapa

    store.mainConfigStore.pluLoad() //avisar para todos que o loading do plu acabou (componentes que tem intenção de usar as medições)
    store.mainConfigStore.measurementsLoad()
  })
}

const fluLoad = async () =>{
  configInterval()
  progressBarHandler()
  mapOverlay.show()
  
  let response = await stationHelper.getMeasurements('flu')

  let OBJ = {}

  response.measurements.forEach(measurement=>{
    if(!OBJ[measurement.station_prefix_id]){
      OBJ[measurement.station_prefix_id] = {...measurement, measurements:[]}
      
      let reference_value = response.references.find(x=>parseInt(x.parameterizable_id) === parseInt(measurement.station_prefix_id))

      OBJ[measurement.station_prefix_id].parameter = reference_value
    }
    OBJ[measurement.station_prefix_id].measurements.push(measurement)
  })

  store.fluConfig.setStations(Object.values(OBJ))
  
  response.measurements.forEach(measurement=>{
    store.fluConfig.setStationProp(measurement.station_prefix_id, 'value')
  })

  store.fluConfig.getStations().map(station=>{
    let ms = response.measurements.filter(x=>x.station_prefix_id === station.id)
    store.fluConfig.setStationProp(station.id, 'measurements', ms)
  })
  
  markersComponent.filterMarkers()

  offcanvasController.update()

  mapOverlay.hide()

  store.mainConfigStore.measurementsLoad()

}


function initialMapLoad(){
  map = L.map('map', {searchControl: true,attributionControl: false}).setView([-22.56, -47.65], 6);
  // let custom = new custom_layer()

  //adicionando camadas que irão conter markers do mapa
  map.addLayer(markers_group);
  map.addLayer(markers_pulse_group);

  markers_monitored_spots.addTo(map)

  //adicionando camadas que irão conter WFS do mapa
  map.addLayer(featureGroupUgrhiLimit);
  map.addLayer(featureGroupCityLimit);
  loadGeoserverlayers();

  // loadMeasurements(hours);
  MapController.addLayerControl();
  MapController.addElementFilter();
  MapController.addElementHours();
  // MapController.addElementMonitoredSpots(); //element de pontos monitorados
  MapController.addElementCity();

  //desabilitando zoom padrão por scroll do mouse do leaflet
  map.scrollWheelZoom.disable()

  markersComponent = new MarkersComponent({map})

  chartModal = new ChartModal({
    modal_options: {period_selector:{time_picker:true}},
    forecastOptions:{
      flu:{
          show: global.CAN_SEE_RADAR_DAEE
      }
  }
  })
  chartModal.generate()

  let landSlide = new LandSlide({map:map}) //componente controlador da view de landslide

  let type_selector = new TypeSelector()

  let lightning_component = new Lightning({map:map})

  let popUpComponent = new PopUpComponent({chartModal:chartModal /*gamb */})

  store.mapConfigStore.subscribe('SET_POPUP_OPTIONS', data=>{    
    popUpComponent.show([data.obj.latitude || data.obj.station.latitude, data.obj.longitude || data.obj.station.longitude], data, map)
  })

  store.fluConfig.subscribe('UPDATE_FILTER_OPTIONS', filter_options =>{
    if(filter_options.ugrhi_cods.length > 0){
      geoJSONHelper.addLimitLayerToMap(map, 'ugrhi_limit', {ugrhi_cods: filter_options.ugrhi_cods})
    } else {
      geoJSONHelper.clearFeatureLayer()
    }
  })

  var element = L.control({position: 'topright'})

  element.onAdd = function () {
    var div = L.DomUtil.create('div', 'dom-element-default dom-element-type-selector');

    $(div).html(type_selector.generate())

    return div;
  }
  
  element.addTo(map);

  //botão 'direito' click no mapa
  map.on('contextmenu',(e) => {
    popUpComponent.show(e.latlng, {type: 'context'}, map)
  });

  let mapNavbarController = new MapNavbarController()

  if(CAN_SEE_RADAR_DAEE){
    let timelineController = new TimelineController()
    timelineController.generate()
  }
  

}

function loadGeoserverlayers(){
  MapController.loadLayerEstateLimits();
}

function alertNewEvents(events){
  // let event_alert = new EventAlert()
  events.forEach(event=>{
    events_handler.addEvent({type: 'new_rain_event', prefix: event.prefix, value: event.value, date_hour:event.max_date})
    // event_alert.showRainEvent({title: "NOVO EVENTO DE CHUVA", prefix: event.prefix, value: event.value, date: event.date_hour})  
  })
  
}

const options = [
  {name: 'Swedish', value: 'sv'},
  {name: 'English', value: 'en'},
  {
      type: 'group',
      name: 'Group name',
      items: [
          {name: 'Spanish', value: 'es'},
      ]
  },
];

function addSupporters(){
  $('section').append('<div class="supporters-wrapper"></div>')
  let supporters = new Supporters({entities_show:{daee:true, iac:true, ana:true, fundag:true, cemaden:true}})
  supporters.generateToContainer('.supporters-wrapper')
}

function setDefaultFilter(ugrhis_cods){
  $("#checkbox_default_filter").prop("checked",true)
}

function debounce(func, wait, immediate) {
  var timeout;

  return function executedFunction() {
    var context = this;
    var args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
};
function mobileCheck() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function setHighchartsConfig(){
  var timezone = new Date().getTimezoneOffset()
  Highcharts.setOptions({
    time: {
        timezoneOffset: timezone
    },
    lang: {
        months: moment.months(),
        shortMonths: moment.monthsShort()
    }
  });
}

function buildFilter(){
  let _filter_form = new filter_form({container: '#offcanvas_filter .content'})
  _filter_form.generate()
  
}

function setUserOptions(){
  let options = localStorage.getItem("raining_now_user_options")
  if(!options){
    localStorage.setItem("raining_now_user_options", JSON.stringify(user_options))
  } else {
    user_options = JSON.parse(options)
  }
  $.each($('.config-option-container'), (index, element)=>{
    let key = element.dataset.id
    $(element).toggleClass('active', user_options[key])
  })
}